const DEFAULT_DURATION = {
  seconds: 0,
  parsed: '-:-',
};

const DEFAULT_PROGRESS = {
  seconds: 0,
  parsed: '-:-',
  percentage: 0,
};

const CONTENT_TYPES = { SONG: 'song', RADIO: 'radio', SPOT: 'spot', PODCAST: 'podcast', DJ: 'dj' };

const SKIPS_AFTER_SPOT = 5;

const METRICS_TYPES = {
  UNKNOWN: 0,
  RADIO_ARTIST: 1,
  RADIO_GENRES: 2,
  PLAYLIST_SYSTEM: 3,
  PLAYLIST_USER: 4,
  PLAYLIST_FREE: 5,
  PLAYLIST_PROMO: 7
};

const ERRORS_CODE = {
  MEDIA_ERR_ABORTED: 1,
  MEDIA_ERR_NETWORK: 2,
  MEDIA_ERR_DECODE: 3,
  MEDIA_ERR_SRC_NOT_SUPPORTED: 4,
  INVALID_TOKEN: 5,
  INVALID_RADIO: 6,
};

const TYPE_CONTENT = {
  SONG_TYPE: 'song',
  DJ_TYPE: 'dj',
  RADIO_TYPE: 'radio',
  PODCAST_TYPE: 'podcast',
  SPOT_TYPE: 'spot'
};

const PLAYER_REPEAT_MODES = {
  SIMPLE: 0,
  REPEAT_SINGLE: 1,
  REPEAT_ALL: 2
};

const DMCA_RULES = {
  FREE_PLAYLIST_ALBUM_SONGS_PLAYED: 6,
  FREE_PLAYLIST_SONGS_CONSECUTIVE_PLAYED: 3,
  FREE_PLAYLIST_SONGS_PLAYED_TIME: 3600
};

const ACCESS_TYPES = {
  UNKNOWN: 0,
  USER_PLAYLIST: 1,
  FREE_PLAYLIST: 2,
  NO_FREE_PLAYLIST: 3,
  EVENTS: 4,
  ARTIST: 5,
  SEARCH: 6,
  FAVORITES: 7,
  TOP_SONGS: 8,
  ALBUM: 9,
  DJS: 10,
  RADIO_GENRE: 11,
  RADIO_ARTIST: 12,
  SYSTEM_PLAYLIST: 13,
  PROMO_PLAYLIST: 14
};

const USER_TYPES = {
  ANONYMOUS: 0,
  FREE: 1,
  PREMIUM: 2
};

module.exports = {
  DEFAULT_DURATION,
  DEFAULT_PROGRESS,
  CONTENT_TYPES,
  SKIPS_AFTER_SPOT,
  METRICS_TYPES,
  ERRORS_CODE,
  TYPE_CONTENT,
  PLAYER_REPEAT_MODES,
  DMCA_RULES,
  ACCESS_TYPES,
  USER_TYPES
};



// WEBPACK FOOTER //
// ./src/constants/musica/player.jsx